import React, { useState } from 'react';
import axios from 'axios';

export default function DesignProjectsList({ projects, next_page_link }) {

  const [loadedMoreList, setLoadedMoreList] = useState([]);
  const [nextLink, setNextLink] = useState(next_page_link);

  const clickLoadMore = json_path => {

    axios.get(json_path).then(res => {
      setNextLink(res.data.next_page_link);
      setLoadedMoreList(loadedMoreList.concat(res.data.projects));
    });
  };

  if (projects.length === 0) {
    return <div className="design-projects-empty">There is no designs in this category</div>;
  }
  return (
    <div>
      <div className="design-projects-list">
        {projects.concat(loadedMoreList).map((project, index) => (
          <div className="design-projects-list_item" key={`item-${project.id}`}>
            <div className="design-project-preview">
              <a href={project.link} className="design-project-preview_link">
                <div className="design-project-preview_image">
                  {project.image && <img src={project.image} />}
                </div>
                <div className="design-project-preview_hover">
                  <div className="design-project-preview_hover-inner">View this design</div>
                </div>
              </a>
              <div className="design-project-preview_title">{project.headline}</div>
            </div>
          </div>
        ))}
      </div>
      {nextLink && (
        <div className="design-projects-list_load-more">
          <button className="btn -gold" onClick={() => clickLoadMore(nextLink)}>Load More &#62;&#62;</button>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/design_projects_list/index.js